<script>
export default {
  locales: {
    pt: {
      'TECHNOLOGY BY': 'TECNOLOGIA POR',
    },
    es: {
      'TECHNOLOGY BY': 'TECNOLOGÍA POR',
    },
  },
}
</script>

<template>
  <p class="my-5 font-size-12 text-uppercase text-muted text-center">
    <a class="text-muted font-size-11" target="_blank" href="https://m2n.com.br/?utm_source=nexteev.com&utm_medium=link&utm_campaign=logo">
      <small>{{ t('TECHNOLOGY BY') }}</small> <img alt="M2N" style="width:40px;" src="@/assets/images/logo-m2n.svg" />
    </a>
  </p>
</template>